import { css } from "../../css/util.compose-css";

export const image = css`
  border: 0;
  display: block;
`;

export const basicImage = css`
  height: 100%;
  width: 100%;
`;

export const picture = css`
  display: block;
  line-height: 0;
`;
